import React, { useContext, useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { contextpass } from "../App";
import skillsimg from "../images/skills-inner.png";

// import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";
import SkillSet1 from "../components/SkillSet1";
import SkillSet2 from "../components/SkillSet2";
import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";
import { Helmet } from "react-helmet";

function Skills() {
  const { pass } = useContext(contextpass);
  const [mode] = pass;
  const [skills, setskills] = useState(false);
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end

  return (
    <section
      className={
        mode === true
          ? "align-items-center row bg-6"
          : "align-items-center row bg-5"
      }
    ><Helmet>
    <meta
      name="description"
      content="As a front-end developer, design and development are very important
to me. I think my technical expertise and sense of aesthetics make
me a well-rounded developer who can handle any challenge."
    />
    <title>Skills - Muhammed Mubashir</title>
  </Helmet>
     
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      >
        <div className="inner-sec row gy-md-4 gy-3">
          <h2 className="sec-head">Skills</h2>
          {skills === true ? <SkillSet2 /> : <SkillSet1 />}

          <div className="m-0 text-end">
           
            <motion.button
              className="btn change-skill"
              initial={{ opacity: 0.6 }}
              whileHover={{
                scale: 1.1,
                transition: { duration: 1 },
              }}
              whileTap={{ scale: 0.9 }}
              whileInView={{ opacity: 1 }}
              onClick={() => setskills((e) => !e)}
            >
              {skills === true ? (
                <BsFillArrowLeftSquareFill />
              ) : (
                <BsFillArrowRightSquareFill />
              )}
            </motion.button>
          </div>
          
        </div>
      </motion.div>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12 text-center"
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}
      >
        <img src={skillsimg} alt="skills" className="sec-img-w" />
      </motion.div>
    </section>
  );
}

export default Skills;
